import PropTypes from 'prop-types';

import proNotifications from 'modules/proNotifications';

import AvatarIcon from 'components/AvatarIcon';
import RatingStars from 'components/RatingStars';
import StateLink from 'components/StateLink';

import './Notification.scss';
import './ClientReview.scss';

/**
 * Client review notification
 */
export default function ClientReview(props) {
  const { notification } = props;
  return (
    <StateLink
      to="responsive.provider.ratings_reviews"
      params={{
        providerId: notification.provider_id,
      }}
      clickTracking={{
        name: proNotifications.NOTIFICATION_CLICKED_EVENT,
        params: proNotifications.createNotificationParams(notification),
      }}
    >
      <section className="client-review notification">
        <div className="icon">
          <AvatarIcon
            icon={notification.client_thumbnail}
            name={notification.client_name}
          />
        </div>
        <section className="notification-body">
          <p className="notification-text review-text">
            <strong>
              {notification.client_name} left a review
            </strong>
            <span>
              {` "${notification.review_text}"`}
            </span>
          </p>
          <RatingStars ratingStars={notification.num_stars} centered={false} />
          <p className="from-now">
            {proNotifications.getFromNowDisplay(notification.creation_time)}
          </p>
        </section>
      </section>
    </StateLink>
  );
}

ClientReview.propTypes = {
  /** The notification object */
  notification: PropTypes.object.isRequired,
};
